import styles from './styles.less';
import React from 'react';
import cx from 'classnames';
import * as Config from '../../constants/config';

class UploadForm extends React.Component {

	constructor(props) {
        super(props);
        this.state = {
            shown: true,
            nameError: false,
            emailError: false,
            agreeError: false,
            uploading: false,
            thanks: false,
            nameValue: '',
            emailValue: '',
            agreeValue: '',
        };
    }

    render() {
    	const imageUrl = this.props.imageUrl;

    	let className = cx(styles.root, this.props.className, {
            [styles.shown]: this.state.shown,
            [styles.hide]: !this.state.shown
        });

        const nameInputWrapperStyles = cx(styles.inputWrapper, {
            [styles.error]: this.state.nameError
        });

        const emailInputWrapperStyles = cx(styles.inputWrapper, {
            [styles.error]: this.state.emailError
        });

        const agreeInputWrapperStyles = cx(styles.checkboxWrapper, {
            [styles.error]: this.state.agreeError
        });

    	return (
        <div
            className={ className }
            onAnimationEnd={ this.handleAnimationEnd }>
            <div
                className={ styles.close }
                onClick={ this.handleOverlayClose }>
                <img src="https://i.cdn.turner.com/adultswim/big/img/2017/02/09/upload-close.png" />
            </div>

            { this.state.thanks &&
            <div className={ styles.thanks }>
                <img src="https://i.cdn.turner.com/adultswim/big/img/2017/02/13/thanks.png" />
            </div>
                }

            { !this.state.thanks &&
            <span>
                <div className={ styles.previewArea }>
                    <div className={ styles.previewImage }>
                        <img src={ imageUrl } />
                    </div>

                    <div className={ styles.uploadCopy }>
                        <img src="https://i.cdn.turner.com/adultswim/big/img/2017/02/09/submit-description.png" />
                    </div>
                </div>

                <div className={ styles.formWrapper }>
                    <form
                        onSubmit={ this.handleFormSubmit }>

                        <div className={ nameInputWrapperStyles }>
                            <label htmlFor="input-name">Name:</label>
                            <input
                                name='name'
                                onChange={ this.handleChange }
                                type='text'
                                value={ this.state.nameValue }
                            />
                        </div>

                        <div className={ emailInputWrapperStyles }>
                            <label htmlFor="input-email">Email:</label>
                            <input
                                name='email'
                                onChange={ this.handleChange }
                                type='text'
                                value={ this.state.emailValue }
                            />
                        </div>

                        <div className={ agreeInputWrapperStyles }>
                            <input
                                checked={ this.state.agreeValue ? 'checked' : null }
                                name='agree'
                                onChange={ this.handleChange }
                                type='checkbox'
                            />
                            <label htmlFor="input-checkbox">I agree to these
                                <a
                                    href="/footer/legal/submit-your-drawing.html"
                                    target="_blank">rules
                                </a>
                            </label>
                        </div>

                        <div className={ styles.submitWrapper }>
                            <input
                                name="submit"
                                src="https://i.cdn.turner.com/adultswim/big/img/2017/02/09/submit-button-white.png"
                                type="image"
                                value="submit"
                            />

                            { this.state.uploading &&
                                <img
                                    className={ styles.loadingIcon }
                                    src="https://i.cdn.turner.com/adultswim/big/img/2017/02/13/workingWhite.gif"
                                /> }
                        </div>
                    </form>
                </div>
            </span>
                }
        </div>
	    );
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name + 'Value']: value
        });
    }

    handleOverlayClose = () => {
        this.setState({
            shown: false
        });
    }

    handleAnimationEnd = () => {
    	if (!this.state.shown) this.props.handleUploadFormClose();
    }

    handleFormSubmit = (event) => {
        event.preventDefault();

    	this.setState({
            nameError: !this.state.nameValue,
            emailError: !this.state.emailValue,
            agreeError: !this.state.agreeValue
    	});

    	if (!this.state.nameValue || !this.state.emailValue || !this.state.agreeValue) return false;

        this.setState({
            uploading: true
        });

        const finalData = {
            name: this.state.nameValue,
            email: this.state.emailValue
        };

        fetch(Config.IMAGE_UPLOAD_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'dataURL': this.props.imageUrl,
                'save': true,
                'metadata': finalData
            })
        }).then(() => {
            this.setState({ uploading: false, thanks: true });
        }).catch((err) => {
            console.log(err);
        });

    	// this.props.uploadImage(this.props.imageUrl, finalData, true)
        //     .then(() => {
        //
        //     });
    }

}


export default UploadForm;



// WEBPACK FOOTER //
// ./src/client/components/upload-form/index.js